"use strict";
// @ts-ignore
try {
    self['workbox:expiration:6.2.4'] && _();
}
catch (e) { }
